import { Injectable } from '@angular/core'
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot } from '@angular/router'
import {
  GlobalMessageService,
  GlobalMessageType,
  UserIdService
} from '@spartacus/core'
import { MbConstants } from '../../shared/mb-constants'
import { of } from 'rxjs'
import { filter, map, switchMap, take, tap, withLatestFrom } from 'rxjs/operators'
import { MbCheckoutTypes } from '../../models'
import { MbCheckoutReviewPricesConnector } from '../connectors/review-prices'
import { MbCheckoutNavigationService } from '../services/mb-checkout-navigation.service'
import { ActiveCartService, MultiCartService } from '@spartacus/cart/base/core'

@Injectable({
  providedIn: 'root'
})
export class CheckoutReviewPageGuard implements CanActivate {

  constants = MbConstants
  checkoutTypes = MbCheckoutTypes

  constructor (protected activeCartService: ActiveCartService,
               protected userIdService: UserIdService,
               protected mbCheckoutReviewPricesConnector: MbCheckoutReviewPricesConnector,
               protected multiCartService: MultiCartService,
               protected mbCheckoutNavigationService: MbCheckoutNavigationService,
               protected globalMessageService: GlobalMessageService) {
  }

  canActivate (router: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    return this.activeCartService.getActive().pipe(
      filter(cart => Boolean(cart.code)),
      take(1),
      switchMap(cart => {
        const { code } = cart
        const { checkoutType } = cart.checkoutStatus || {}
        const { CHECKOUT_TYPE_D, CHECKOUT_TYPE_E } = this.checkoutTypes
        const isPurchaseCheckoutType = checkoutType === CHECKOUT_TYPE_D || checkoutType === CHECKOUT_TYPE_E
        return isPurchaseCheckoutType && code && this.mbCheckoutReviewPricesConnector.get(code).pipe(
          withLatestFrom(this.userIdService.getUserId()),
          tap(([simulatedCart, userId]) => {
            if (simulatedCart?.removedProducts?.length > 0) {
              const removedCodes = simulatedCart.removedProducts.toString()?.replaceAll(',', ', ')
              this.globalMessageService.add({
                  key: 'mbcart.orderSimulateMessage',
                  params: { productCodes: removedCodes } },
                GlobalMessageType.MSG_TYPE_ERROR, 17000)

              if (simulatedCart?.entries?.length === 0) {
                this.mbCheckoutNavigationService.navigateToCartPage({
                  key: 'mbcart.orderSimulateMessage',
                  params: { productCodes: removedCodes }
                })
              }
            }
            return this.multiCartService.loadCart({
              cartId: simulatedCart.code,
              userId: userId
            })
          }),
          switchMap(() => this.activeCartService.getActive()),
          take(1),
          map(() => true)
        ) || of(true)
      })
    )
  }
}
